export default __webpack_public_path__ + "static/media/element_71.ed738c47.jpg";